import React from 'react';

/**
 * PageLoader – Logo + animated loading. Use for page/section loading states.
 * @param {string} [message] – Text below the loader (e.g. "Loading businesses...")
 * @param {string} [className] – Extra classes for the outer container (e.g. "py-20", "min-h-[50vh]")
 * @param {boolean} [fullScreen] – If true, uses min-h-screen and centers; good for route-level loading
 */
const PageLoader = ({ message = 'Loading...', className = '', fullScreen = false }) => {
  return (
    <div
      className={`
        flex flex-col items-center justify-center
        ${fullScreen ? 'min-h-screen bg-gray-50 dark:bg-gray-950' : 'py-16'}
        ${className}
      `}
    >
      <div className="relative flex flex-col items-center">
        {/* Logo with pulse + soft glow */}
        <div className="relative">
          <div
            className="absolute inset-0 rounded-full bg-primary-500/20 dark:bg-primary-400/20 blur-2xl animate-loader-glow"
            aria-hidden
          />
          <img
            src="/digi_fatehabad_logo.png"
            alt="Digital Fatehabad"
            className="relative w-20 h-20 md:w-24 md:h-24 object-contain animate-loader-logo"
          />
        </div>

        {/* Animated dots bar under logo */}
        <div className="mt-6 flex justify-center gap-1.5" aria-hidden>
          {[0, 1, 2, 3, 4].map((i) => (
            <span
              key={i}
              className="w-2 h-2 rounded-full bg-primary-500 dark:bg-primary-400 animate-loader-dot"
              style={{ animationDelay: `${i * 0.12}s` }}
            />
          ))}
        </div>

        {/* Shimmer progress line */}
        <div className="mt-4 w-32 h-0.5 rounded-full bg-gray-200 dark:bg-gray-700 overflow-hidden">
          <div className="h-full w-1/2 rounded-full bg-primary-500 dark:bg-primary-400 animate-loader-shimmer" />
        </div>

        {/* Message */}
        {message && (
          <p className="mt-5 text-sm md:text-base text-gray-500 dark:text-gray-400 animate-pulse">
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default PageLoader;
